import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import DropdownItem from 'react-bootstrap/DropdownItem';
import ConfirmationModal from '@enerex/unified-ui-react/ConfirmationModal';

import { useToggle } from 'hooks';
import DeleteIcon from '@enerex/unified-ui-react/icons/DeleteIcon';

type DeleteButtonProps = {
    title?: string;
    message?: React.ReactNode;
    onDelete: () => Promise<void>;
    variant?: 'button' | 'icon' | 'iconComponent' | 'dropdownItem';
    disabled?: boolean;
    label?: React.ReactNode;
    confirmLabel?: string;
    showCancelButton?: boolean;
};

const DeleteButton = ({
    title,
    message,
    onDelete,
    variant = 'button',
    disabled,
    label: text = 'Delete',
    confirmLabel = 'Ok'
}: DeleteButtonProps) => {
    const { isOpen, show, hide } = useToggle();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleDelete = async () => {
        try {
            setIsLoading(true);
            await onDelete();
        } finally {
            setIsLoading(false);
            hide();
        }
    };

    return (
        <>
            {/* Trigger Button */}
            {variant === 'iconComponent' ? (
                <DeleteIcon
                    role="button"
                    style={{ fontSize: 18, marginLeft: 6 }}
                    onClick={show}
                />
            ) : variant === 'dropdownItem' ? (
                <DropdownItem onClick={show} disabled={disabled}>
                    {text}
                </DropdownItem>
            ) : (
                <Button variant="danger" onClick={show} disabled={disabled}>
                    {text}
                </Button>
            )}

            <ConfirmationModal
                dialogClassName="modal-md"
                show={isOpen}
                onHide={hide}
                size="lg"
                scrollable
                centered
                title={title || 'Are you sure?'}
                confirmButtonLabel={confirmLabel}
                confirmButtonVariant="danger"
                isLoading={isLoading}
                onConfirm={handleDelete}
            >
                {message || 'Are you sure you want to delete?'}
            </ConfirmationModal>
        </>
    );
};

export default DeleteButton;
